import React from 'react';
import { interpolate } from '@format/interpolate';
import { SlideoutMenuLink } from '../SlideoutMenuLink';
import { SlideDownMenuLink } from '../SlideDownMenuLink';
import { ReferAFriendLink, HeaderLink } from './HeaderLink';
import { NavigationMenuLink } from './styles';

const getLinkText = (link, formattedAmount) => {
  const text = link.linkText ?? link.text;
  if (!text) return text;
  return formattedAmount ? interpolate(text, { offer: formattedAmount }) : text;
};

export const renderNavigationLink = (
  link,
  index,
  {
    linkFontColor,
    closeMenu,
    menuBgColor,
    formattedAmount,
    type = 'mobile',
    variant = 'nav',
  } = {},
) => {
  const { component } = link;
  const key = (component ?? link.target ?? 'link') + index;

  if (component === 'slideout_menu_link') {
    return (
      <NavigationMenuLink
        key={key}
        $variant={variant}
        $fontColor={linkFontColor}
      >
        <SlideoutMenuLink
          {...link}
          linkText={getLinkText(link, formattedAmount)}
          onCloseMenu={closeMenu}
        />
      </NavigationMenuLink>
    );
  }

  if (component === 'slide_down_menu_link') {
    return (
      <NavigationMenuLink
        key={key}
        $variant={variant}
        $fontColor={linkFontColor}
      >
        <SlideDownMenuLink
          {...link}
          onCloseMenu={closeMenu}
          menuBgColor={menuBgColor}
        />
      </NavigationMenuLink>
    );
  }

  if (component === 'refer_a_friend_button') {
    return (
      <NavigationMenuLink
        key={key}
        $variant={variant}
        $fontColor={linkFontColor}
      >
        <ReferAFriendLink position={index} {...link} type={type} />
      </NavigationMenuLink>
    );
  }

  return (
    <NavigationMenuLink key={key} $variant={variant} $fontColor={linkFontColor}>
      <HeaderLink
        target={link.target}
        position={index}
        text={getLinkText(link, formattedAmount)}
        type={type}
        onClick={closeMenu}
      />
    </NavigationMenuLink>
  );
};
